import React from 'react';
import {KTMScreen,ActionEvent,RenderEvent,renderScreen} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {Layout,Dialog,Display,Card,Button} from 'ktm-ui';

interface Ioverpayment {
    SeqNo:number;
    Employee_Id:string;
    AccountType:string;
    TransType:string;
    TransDate:string;
    Claim_Id:string;
    RefNo:string;
    TransAmount:number;
    CreatedAt:string;
    CreatedBy:string;
};

export default KTMScreen({name:"enroll.employee.add-overpayment"}, class extends React.Component<{employee_id:string}> {

    data:{
        overpayment:Ioverpayment;
    }

    render(){
        return renderScreen(this);
    }

    async start({screen}:ActionEvent){
        screen.defaultRecord = "@overpayment";
        await KTMApi.start(screen,{
            "@employee_id":this.props.employee_id,
        });
        screen.title = "Add overpayment";
    }

    main({field,draw,action}:RenderEvent){
        return (
            <Layout>
                {draw(this.header)}
                {draw(this.details)}
                {draw(this.footer)}
            </Layout>
        );
    }

    header({field,draw,action}:RenderEvent){
        return (
            <Dialog.Header label="Add employee overpayment">
            </Dialog.Header>
        );
    }

    details({field,draw,action}:RenderEvent){
        return (
            <Card label="Details">
                <Display field={field("AccountType")}/>
                <Display field={field("TransDate")}/>
                <Display field={field("RefNo")}/>
                <Display field={field("TransAmount")}/>
            </Card>
        );
    }

    footer({field,draw,action}:RenderEvent){
        return (
            <Dialog.Footer>
                <Button action={action(this.submit)} label="Save" size="large" style="primary"/>
            </Dialog.Footer>
        );
    }

    async submit({screen}:ActionEvent){
        await KTMApi.action(screen,"submit",{
            "@employee_id":this.props.employee_id,
            "@overpayment.AccountType":this.data.overpayment.AccountType,
            "@overpayment.TransDate":this.data.overpayment.TransDate,
            "@overpayment.RefNo":this.data.overpayment.RefNo,
            "@overpayment.TransAmount":this.data.overpayment.TransAmount,
        });
        screen.close({"continue":true});
    }

});
